import api from './api';

export async function recordAcceptingTermsAndConditions(version: string) {
  await api.post('/terms-consent', { version });
}
